module.exports = __webpack_public_path__ + "images/CEBSB_goodnews_bg_up_2025_2026_en_2.1789097746312.jpg";